import { render, staticRenderFns } from "./FeedbackAverage.vue?vue&type=template&id=84655b24&"
import script from "./FeedbackAverage.vue?vue&type=script&lang=js&"
export * from "./FeedbackAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stevetentrop/workspace/developer-environment/plugins/Feedback/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84655b24')) {
      api.createRecord('84655b24', component.options)
    } else {
      api.reload('84655b24', component.options)
    }
    module.hot.accept("./FeedbackAverage.vue?vue&type=template&id=84655b24&", function () {
      api.rerender('84655b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/FeedbackAverage.vue"
export default component.exports